/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import { StyledPriceIncludeTaxesDiv } from './priceTaxFilter.styles';
import { Checkbox } from '@marriott/mi-ui-library-shop';
// import { Heading } from '@marriott/mi-ui-library';
// import { CheckBox } from '@marriott/mi-ui-library';
// import { useWindowSize } from '@marriott/mi-ui-library';

declare module 'react' {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  interface HTMLAttributes<T> {
    custom_click_track_value?: string;
  }
}
type PriceTaxFilterProps = {
  handleDynamicPricesAndTax: (val: boolean) => void;
  isTaxSliderActive: boolean;
  filterTaxesLabel?: string;
};

export const ShowPriceTaxFilter: React.FC<PriceTaxFilterProps> = ({
  handleDynamicPricesAndTax,
  isTaxSliderActive,
  filterTaxesLabel,
}) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const clickTrackingLoc = 'Phoenix Search Results';
  const [isTaxesSliderActive, setIsTaxesSliderActive] = useState<boolean>(isTaxSliderActive);
  // const { width } = useWindowSize();

  useEffect(() => {
    setIsTaxesSliderActive(isTaxesSliderActive);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isTaxSliderActive]);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any

  const handleTaxesSelection = (event: any): void => {
    event?.stopPropagation();
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      handleDynamicPricesAndTax(!isTaxesSliderActive);
      setIsTaxesSliderActive(!isTaxesSliderActive);
      // setInteractionsSelected({ ...interactionsSelected, taxesAndFees: true });
    }
  };

  return (
    <div>
      <StyledPriceIncludeTaxesDiv className="col-12 pl-0 t-label-alt-m">
        <label
          className="col-11 pl-0 include-taxes-and-fees-price-label t-font-s custom_click_track"
          tabIndex={-1}
          aria-hidden
          {...{
            custom_click_track_value: `${clickTrackingLoc}|${filterTaxesLabel} |internal`,
          }}
        >
          {filterTaxesLabel}
        </label>
        <Checkbox
          checkboxId="include-taxes-and-fees-price"
          onChange={(): void => {
            handleDynamicPricesAndTax(!isTaxesSliderActive);
            setIsTaxesSliderActive(!isTaxesSliderActive);
          }}
          checkboxName="include-taxes-and-fees-price"
          variation="switch"
          inputClassName="custom_click_track"
          checked={isTaxesSliderActive}
          {...{
            custom_click_track_value: `${clickTrackingLoc}| ${filterTaxesLabel} |internal`,
            tabIndex: -1,
          }}
          children={<span className="ada-hide">{filterTaxesLabel} </span>}
          ariaLabel={filterTaxesLabel}
          setTabIndex={-1}
          onKeyDown={(e): void => handleTaxesSelection(e)}
        />
        <hr className="filter-separator mt-4 mt-md-5 mt-lg-5 mt-xl-5" />
      </StyledPriceIncludeTaxesDiv>
    </div>
  );
};
